import {makeOwnDisplayName} from '../../adjustment-pricing-grid/services/portfolio-groups';
import {
    ClientPortfolioForCurrentZoneTemplate,
    CurrentZoneTemplateDescriptor,
    CurrentZoneTemplateAssignment, CurrentZoneTemplateData, CurrentZoneTemplateType
} from "./zone-template.class";
import {ShellClientService} from "../../shell-communication/shell-client.service";
import {
    GetAllCurrentZoneTemplates, GetAllCurrentZoneLevelsTemplatesReply, GetAssignmentData,
    GetAssignmentDataReply, GetCurrentZoneLevelsTemplateDataReply, GetCurrentZoneTemplateData,
    GetCurrentZoneTemplatesByType, GetCurrentZoneTemplatesByTypeReply, SaveCurrentZoneTemplate,
    DeleteCurrentZoneTemplate, GetPortfolioCurrentZoneDataReply, GetPortfolioCurrentZoneData, SetCurrentZoneLevel, SetCurrentZoneLevel3,
    SetAssignmentData, GetZoneTypeGrants, GetZoneTypeGrantsReply, SetZoneTypeGrant, ZoneTypeGrantValue
} from "./cqrs.class";
import {ServiceConfiguration} from "../../adjustment-pricing-grid/services/ServiceConfiguration";
import {SessionService} from "../../authentication/session-service.service";
import {CashFlowPortfoliosService} from "../../adjustment-pricing-grid/services/cashflow-portfolios.service";
import {UserDto} from "../../authentication/dtos/auth-result-dto.inteface";
import {Injectable} from "@angular/core";


export abstract class CurrentZoneService {

    abstract getTemplatesByType(selectedTemplateType: CurrentZoneTemplateType): Promise<CurrentZoneTemplateDescriptor[]>;

    abstract getCurrentZoneLevelsTemplateData(templateId: string): Promise<CurrentZoneTemplateData>;

    abstract getAssignmentData(): Promise<CurrentZoneTemplateAssignment[]>

    abstract getAllClientPortfolios(): ClientPortfolioForCurrentZoneTemplate[];

    abstract getAllTemplates(): Promise<CurrentZoneTemplateDescriptor[]>

    abstract saveTemplate(template: CurrentZoneTemplateDescriptor, data: CurrentZoneTemplateData) : Promise<void>;

    abstract deleteTemplate(id: string): Promise<void>;

    abstract getPortfolioData(portfolioId: string): Promise<GetPortfolioCurrentZoneDataReply>

    abstract setAsCurrentZone(portfolioId: string, level: number): Promise<void>;

    /** Owner ruling 2026-09-15: the Type 3 manual set. Super users only; the backend refuses everyone else. */
    abstract setAsCurrentZone3(portfolioId: string, level: number): Promise<void>;

    /**
     * Saves the assignments of the portfolios in `portfolioIds` (every portfolio the dialog
     * listed). Rows of other portfolios - other super users' users - are left untouched.
     */
    abstract setAssignments(data: CurrentZoneTemplateAssignment[], portfolioIds: string[]): Promise<void>

    abstract getAssignments(): Promise<CurrentZoneTemplateAssignment[]>

    /**
     * CR-20260904-001, Zones Z5. The per-trader zone TYPE grants (BR-Z1). A super user reads
     * every row; anybody else reads only their own.
     */
    abstract getZoneTypeGrants(): Promise<GetZoneTypeGrantsReply>;

    /** Sets one trader's grant. A null value takes the grant away. */
    abstract setZoneTypeGrant(userId: string, zoneType: ZoneTypeGrantValue | null): Promise<void>;

    /** The users a grant can be given to: every user in the session, own user first. */
    abstract getGrantableUsers(): UserDto[];
}
//
// // Fake Impl
// export class FakeCurrentZoneService implements CurrentZoneService {
//     saveTemplate(template: CurrentZoneTemplateDescriptor, data: CurrentZoneTemplateData): Promise<void> {
//         throw new Error("Method not implemented.");
//     }
//
//     async getAllTemplates(): Promise<CurrentZoneTemplateDescriptor[]> {
//         const t1 = await this.getTemplatesByType('Type 1');
//         const t2 = await this.getTemplatesByType('Type 2');
//
//         const concat = t1.concat(t2);
//         const clone = jsonCloneObject(concat);
//         clone.forEach((item) => {
//             item.isSelected = false
//         });
//         return clone;
//     }
//
//
//     private _type1: CurrentZoneTemplateDescriptor[] = [
//         {
//             id: '1',
//             type: 'Type 1',
//             name: 'Default Template',
//         },
//         {
//             id: '2',
//             type: 'Type 1',
//             name: 'Offsets Portfolio Template',
//         },
//     ]
//
//     private _type2: CurrentZoneTemplateDescriptor[] = [
//         {
//             id: '3',
//             type: 'Type 2',
//             name: 'My Dearest Template',
//         },
//         {
//             id: '4',
//             type: 'Type 2',
//             name: 'Volatility Template',
//         },
//     ];
//
//     getTemplatesByType(selectedTemplateType: CurrentZoneTemplateType): Promise<CurrentZoneTemplateDescriptor[]> {
//         let templates: CurrentZoneTemplateDescriptor[] = [];
//
//         if (selectedTemplateType === 'Type 1') {
//             templates = this._type1;
//         } else {
//             templates = this._type2;
//         }
//
//         return Promise.resolve(templates);
//     }
//
//     getCurrentZoneLevelsTemplateData(templateId: string): Promise<CurrentZoneTemplateData> {
//         const data = {
//             templateId: templateId,
//             settings: {numOfCloses: 3},
//             levels: [
//                 {price: 6670},
//                 {price: 6630},
//                 {price: 6590},
//                 {price: 6500},
//             ]
//         };
//
//         return Promise.resolve(data as any);
//     }
//
//     getAssignmentData(): Promise<CurrentZoneTemplateAssignment[]> {
//         const data = this._type1.concat(this._type2);
//
//         const maps = data.map(t => {
//             const d: CurrentZoneTemplateAssignment = {
//                 templateId: t.id + '',
//                 templateName: t.name,
//                 templateType: t.type,
//             };
//             return d;
//         });
//
//         return Promise.resolve(maps);
//     }
//
//     getAllClientPortfolios(): ClientPortfolioForCurrentZoneTemplate[] {
//         return [
//             {
//                 clientId: 'terry',
//                 portfolioId: 'terry1',
//                 portfolioName: 'Default Portfolio',
//                 clientName: 'Terry',
//                 isSelected: false
//             },
//             {
//                 clientId: 'terry',
//                 portfolioId: 'terry2',
//                 portfolioName: 'Named Portfolio',
//                 clientName: 'Terry',
//                 isSelected: false
//             },
//
//             {
//                 clientId: 'glen',
//                 portfolioId: 'glen1',
//                 portfolioName: 'Default Portfolio',
//                 clientName: 'Glen',
//                 isSelected: false
//             },
//             {
//                 clientId: 'glen',
//                 portfolioId: 'glen2',
//                 portfolioName: '$40 SPX DO Portfolio',
//                 clientName: 'Glen',
//                 isSelected: false
//             },
//
//             {
//                 clientId: 'tom',
//                 portfolioId: 'tom1',
//                 portfolioName: 'Default Portfolio',
//                 clientName: 'Tom',
//                 isSelected: false
//             },
//             {
//                 clientId: 'tom',
//                 portfolioId: 'tom2',
//                 portfolioName: 'Dynamic Offsets',
//                 clientName: 'Tom',
//                 isSelected: false
//             },
//             {
//                 clientId: 'tom',
//                 portfolioId: 'tom3',
//                 portfolioName: 'Hedged Portfolio',
//                 clientName: 'Tom',
//                 isSelected: false
//             }
//         ];
//     }
// }
//

// Real Impl
@Injectable()
export class CurrentZoneServiceImpl implements CurrentZoneService {

    constructor(private _shellService: ShellClientService,
                private _sessionService: SessionService,
                private _portfolioService: CashFlowPortfoliosService
    ) {
    }

    async setAssignments(data: CurrentZoneTemplateAssignment[], portfolioIds: string[]): Promise<void> {
        const cmd = new SetAssignmentData(data, portfolioIds);
        await this._shellService.processCommand(cmd);
    }

    async getZoneTypeGrants(): Promise<GetZoneTypeGrantsReply> {
        const qry = new GetZoneTypeGrants();
        const reply = await this._shellService.processQuery<GetZoneTypeGrantsReply>(qry);
        return reply;
    }

    async setZoneTypeGrant(userId: string, zoneType: ZoneTypeGrantValue | null): Promise<void> {
        const cmd = new SetZoneTypeGrant(userId, zoneType);
        await this._shellService.processCommand(cmd);
    }

    getGrantableUsers(): UserDto[] {
        // Same source the Assign Templates dialog already uses for portfolios: no new backend
        // operation is needed to list users.
        const ownUser = this.getUserObject(this._sessionService.sessionData.userId);

        const others = (this._sessionService.sessionData.users || [])
            .filter(u => u.userId !== this._sessionService.sessionData.userId)
            .slice()
            .sort((a, b) => a.userName.localeCompare(b.userName));

        return [ownUser].concat(others).filter(u => !!u);
    }

    async getAssignments(): Promise<CurrentZoneTemplateAssignment[]> {
        const qry = new GetAssignmentData();
        const reply = await this._shellService.processQuery<GetAssignmentDataReply>(qry);
        return reply.assignments;
    }

    async setAsCurrentZone(portfolioId: string, level: number): Promise<void> {
        const cmd = new SetCurrentZoneLevel(portfolioId, level);
        await this._shellService.processCommand(cmd);
    }

    async setAsCurrentZone3(portfolioId: string, level: number): Promise<void> {
        const cmd = new SetCurrentZoneLevel3(portfolioId, level);
        await this._shellService.processCommand(cmd);
    }

    async getPortfolioData(portfolioId: string): Promise<GetPortfolioCurrentZoneDataReply> {
        const qry = new GetPortfolioCurrentZoneData(portfolioId);
        const result = await this._shellService.processQuery<GetPortfolioCurrentZoneDataReply>(qry);
        return result;
    }

    async deleteTemplate(id: string): Promise<void> {

        const cmd = new DeleteCurrentZoneTemplate(id);
        await this._shellService.processCommand(cmd);

    }

    async getAllTemplates(): Promise<CurrentZoneTemplateDescriptor[]> {
        const qry = new GetAllCurrentZoneTemplates();

        const reply = await this._shellService
            .processQuery<GetAllCurrentZoneLevelsTemplatesReply>(qry);

        reply.templates.forEach(template => template.isSelected = false);

        return reply.templates;
    }

    async getAssignmentData(): Promise<CurrentZoneTemplateAssignment[]> {
        const qry = new GetAssignmentData();
        const reply = await this._shellService.processQuery<GetAssignmentDataReply>(qry);
        return reply.assignments;
    }

    getAllClientPortfolios(): ClientPortfolioForCurrentZoneTemplate[] {
        const pfs = this.portfolios();
        return pfs;
    }

    async getCurrentZoneLevelsTemplateData(templateId: string): Promise<CurrentZoneTemplateData> {
        const qry = new GetCurrentZoneTemplateData(templateId);
        const reply = await this._shellService
            .processQuery<GetCurrentZoneLevelsTemplateDataReply>(qry);
        return reply.data;
    }

    async getTemplatesByType(selectedTemplateType: CurrentZoneTemplateType): Promise<CurrentZoneTemplateDescriptor[]> {
        const qry = new GetCurrentZoneTemplatesByType(selectedTemplateType);
        const reply = await this._shellService
            .processQuery<GetCurrentZoneTemplatesByTypeReply>(qry);
        return reply.templates;
    }

    async saveTemplate(template: CurrentZoneTemplateDescriptor, data: CurrentZoneTemplateData): Promise<void> {
        const cmd = new SaveCurrentZoneTemplate(
            template, data
        );
        await this._shellService.processCommand(cmd);
    }

    private portfolios() {

        const ownUser = this.getUserObject(this._sessionService.sessionData.userId);

        const users = this._sessionService.sessionData.users
            .slice()
            .sort((a, b) => a.userName.localeCompare(b.userName));

        users.unshift(ownUser);

        const grps = users.flatMap(user => {

            const cfg: ServiceConfiguration = {
                orientation: undefined,
                userId: user.userId,
                userName: user.userName
            };

            this._portfolioService.configure(cfg);

            const pfs = this._portfolioService.getPortfolios()
                .map(pf => {
                    const p: ClientPortfolioForCurrentZoneTemplate = {
                        clientId: pf.userId,
                        portfolioId: pf.id,
                        clientName: pf.userName,
                        portfolioName: pf.name,
                        isSelected: false,
                    };
                    return p;
                });

            return pfs;
        });

        return grps;
    }

    private getUserObject(userId: string): UserDto {

        if (this._sessionService.sessionData.userId === userId) {

            const ownUserName = makeOwnDisplayName(this._sessionService.sessionData);

            return {
                userId,
                userName: ownUserName
            };

        } else {

            return this._sessionService.sessionData.users.find(x => x.userId === userId);
        }
    }
}
